import { useEffect } from "react";

import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

import Features from './features';
import Footer from './footer';
import { Globe, Body } from './design';
import Vlogs from './vlogs';
import Project from './project';
import Tos from './components/tos';
import { MyBlogs, CreateBlogs} from './blogs';
import MenuSection from './menu';
import About from './about'

import CreateProjectTemplate from './components/createproject';
import KeepAlive from './components/KeepAlive';
import Py6UIDownload from './whlpage/py6ui_page';

import TutorialFiftheen from './tutorial/tut15';
import TutorialSixtheen from './tutorial/tut16';
import TutorialSeventheen from './tutorial/tut17';
import TutorialNinetheen from './tutorial/tut19';
import TutorialTwenty from './tutorial/tut20';
import TutorialTwentyOne from './tutorial/tut21';
import TutorialTwentyTwo from './tutorial/tut22';
import TutorialTwentyThree from './tutorial/tut23';
import TutorialTwentyFour from './tutorial/tut24';
import TutorialTwentyFive from './tutorial/tut25';
import TutorialTwentySix from './tutorial/tut26';
import TutorialTwentySeven from './tutorial/tut27';
import TutorialTwentyEight from './tutorial/tut28';
import TutorialTwentyNine from './tutorial/tut29';
import TutorialThirty from './tutorial/tut30';
import TutorialThirtyOne from './tutorial/tut31';
import TutorialThirtyTwo from './tutorial/tut32';
import TutorialThirtyThree from './tutorial/tut33';
import TutorialThirtyFour from './tutorial/tut34';
import TutorialThirtyFive from './tutorial/tut35';
import TutorialThirtySix from './tutorial/tut36';
import TutorialThirtySeven from './tutorial/tut37';
import TutorialThirtyEight from './tutorial/tut38';
import TutorialThirtyNine from './tutorial/tut39';
import Header from "./header";

import ShareableBlog from './components/shareableblog'; // Idagdag mo ito

const App = () => {

  return (
    <>
      <Globe />
        <Body>
          <Router>
            <KeepAlive />
            <MenuSection />

            <Routes>{/*content*/}

            <Route path='/' element={<Header />} />

              <Route path='/login' element={<Tos />} />              
              
              <Route path='/blogs' element={ <MyBlogs />} />

              <Route path='/project' element={<Project />} />

              <Route path='/vlogs' element={<Vlogs />} />

              <Route path='/features' element={<Features />} />

              <Route path='/about' element={<About />} />

              <Route path='/createnewblogs' element={<CreateBlogs />} />

              <Route path='/createnewproj' element={<CreateProjectTemplate />} />

              {/* shareable blogs */}
              <Route path='/view-blog/:id' element={<ShareableBlog />} />



              {/*tutorial link */}

              <Route path='/py6ui' element={<Py6UIDownload />} />
              <Route path='/tutorial15' element={<TutorialFiftheen />} />
              <Route path='/tutorial16' element={<TutorialSixtheen />} />
              <Route path='/tutorial17' element={<TutorialSeventheen />} />
              <Route path='/tutorial19' element={<TutorialNinetheen />} />
              <Route path='/tutorial20' element={<TutorialTwenty />} />
              <Route path='/tutorial21' element={<TutorialTwentyOne />} />
              <Route path='/tutorial22' element={<TutorialTwentyTwo />} />
              <Route path='/tutorial23' element={<TutorialTwentyThree />} />
              <Route path='/tutorial24' element={<TutorialTwentyFour />} />
              <Route path='/tutorial25' element={<TutorialTwentyFive />} />
              <Route path='/tutorial26' element={<TutorialTwentySix />} />
              <Route path='/tutorial27' element={<TutorialTwentySeven />} />
              <Route path='/tutorial28' element={<TutorialTwentyEight />} />
              <Route path='/tutorial29' element={<TutorialTwentyNine />} />
              <Route path='/tutorial30' element={<TutorialThirty />} />
              <Route path='/tutorial31' element={<TutorialThirtyOne />} />
              <Route path='/tutorial32' element={<TutorialThirtyTwo />} />
              <Route path='/tutorial33' element={<TutorialThirtyThree />} />
              <Route path='/tutorial34' element={<TutorialThirtyFour />} />
              <Route path='/tutorial35' element={<TutorialThirtyFive />} />
              <Route path='/tutorial36' element={<TutorialThirtySix />} />
              <Route path='/tutorial37' element={<TutorialThirtySeven />} />
              <Route path='/tutorial38' element={<TutorialThirtyEight />} />
              <Route path='/tutorial39' element={<TutorialThirtyNine />} />

            </Routes>

            {/*footer*/}
            <Footer />
          </Router>
        </Body>
    </>
  );
}

export default App;